export default "__VITE_ASSET__CnbWJccp__"